<template>
  <div class="rel">
    <!-- <v-btn class="absolute-close" depressed dark large color="spiceRed" @click="closeModal">
      <v-icon>close</v-icon>
    </v-btn>-->
    <v-card flat class="transparent">
      <v-card-text class="inner-content mt-2">
        <v-layout row wrap>
          <v-flex md7 xs12>
            <h1 class="title pb-3">
              Banking
              <span>Services</span>
            </h1>
            <h2>Bridging the digital gap</h2>
            <p>At Spice Money we are bridging the digital divide between India and Bharat by providing banking services to one and all. Now receive and send money anywhere/anytime across the country instantly and securely.</p>

            <p>We help you send money to family; friends, others, in a safe and secure way. Spice Money provides digital payment solutions to the underserved section of the society through its strong Agent Network using Semi-Closed Wallet.</p>

            <p>Spice Moneys innovative online remittance solutions and extensive reach offers customers a safe, reliable and quick means to transfer money back home.</p>
            <p>
              <strong>Key Features</strong>
            </p>
          </v-flex>
          <v-flex md5 xs12 class="text-xs-center pl-5" v-if="this.$vuetify.breakpoint.lgAndUp">
            <img :src="require('@/assets/images/aeps.jpg')" alt="spice money" width="100%">
          </v-flex>

          <v-flex xs12>
            <ul class="standard-listing two">
              <li>Customers can avoid the hassles of physically visiting banks, and transfer money as per their convenience</li>

              <li>Customers can remit funds to a wide array of banks/locations across the country through real time remittance via intra-bank transfer and the IMPS facility</li>

              <li>Customers get access to more affordable and cost-effective services compared to other available money transfer alternatives</li>

              <li>Customers' money is safe during transit, thanks to the highly secure process with multiple authentication levels</li>

              <li>Walk-in remittance facility is convenient for those who do not have a bank account</li>

              <li>Location and time convenience lead to cost saving for customers as they remit from merchant points</li>
            </ul>
            <div style="clear:both"></div>
            <p class="py-3">
              <strong>The service is available 24X7.</strong>
            </p>

            <ul class="icon-triggers">
              <li :class="aeps?'active':''" @click="aeps=true;dmt=false">
                <!-- <svg style="width:40px;height:40px" viewBox="0 0 24 24">
                  <path
                    fill="#ff7a00"
                    d="M17.81,4.47C17.73,4.47 17.65,4.45 17.58,4.41C15.66,3.42 14,3 12,3C10.03,3 8.15,3.47 6.44,4.41C6.2,4.54 5.9,4.45 5.76,4.21C5.63,3.97 5.72,3.66 5.96,3.53C7.82,2.5 9.86,2 12,2C14.14,2 16,2.47 18.04,3.5C18.29,3.65 18.38,3.95 18.25,4.19C18.16,4.37 18,4.47 17.81,4.47M3.5,9.72C3.4,9.72 3.3,9.69 3.21,9.63C3,9.47 2.93,9.16 3.09,8.93C4.08,7.53 5.34,6.43 6.84,5.66C10,4.04 14,4.03 17.15,5.65C18.65,6.42 19.91,7.5 20.9,8.9C21.06,9.12 21,9.44 20.78,9.6C20.55,9.76 20.24,9.71 20.08,9.5C19.18,8.22 18.04,7.23 16.69,6.54C13.82,5.07 10.15,5.07 7.29,6.55C5.93,7.25 4.79,8.25 3.89,9.5C3.81,9.65 3.66,9.72 3.5,9.72M9.75,21.79C9.62,21.79 9.5,21.74 9.4,21.64C8.53,20.77 8.06,20.21 7.39,19C6.7,17.77 6.34,16.27 6.34,14.66C6.34,11.69 8.88,9.27 12,9.27C15.12,9.27 17.66,11.69 17.66,14.66A0.5,0.5 0 0,1 17.16,15.16A0.5,0.5 0 0,1 16.66,14.66C16.66,12.24 14.57,10.27 12,10.27C9.43,10.27 7.34,12.24 7.34,14.66C7.34,16.1 7.66,17.43 8.27,18.5C8.91,19.66 9.35,20.15 10.12,20.93C10.31,21.13 10.31,21.44 10.12,21.64C10,21.74 9.88,21.79 9.75,21.79M16.92,19.94C15.73,19.94 14.68,19.64 13.82,19.05C12.33,18.04 11.44,16.4 11.44,14.66A0.5,0.5 0 0,1 11.94,14.16A0.5,0.5 0 0,1 12.44,14.66C12.44,16.07 13.16,17.4 14.38,18.22C15.09,18.7 15.92,18.93 16.92,18.93C17.16,18.93 17.56,18.9 17.96,18.83C18.23,18.78 18.5,18.96 18.54,19.24C18.59,19.5 18.41,19.77 18.13,19.82C17.56,19.93 17.06,19.94 16.92,19.94M14.91,22C14.87,22 14.82,22 14.78,22C13.19,21.54 12.15,20.95 11.06,19.88C9.66,18.5 8.89,16.64 8.89,14.66C8.89,13.04 10.27,11.72 11.97,11.72C13.67,11.72 15.05,13.04 15.05,14.66C15.05,15.73 16,16.6 17.13,16.6C18.28,16.6 19.21,15.73 19.21,14.66C19.21,10.89 15.96,7.83 11.96,7.83C9.12,7.83 6.5,9.41 5.35,11.86C4.96,12.67 4.76,13.62 4.76,14.66C4.76,15.44 4.83,16.67 5.43,18.27C5.53,18.53 5.4,18.82 5.14,18.91C4.88,19 4.59,18.87 4.5,18.62C4,17.31 3.77,16 3.77,14.66C3.77,13.46 4,12.37 4.45,11.42C5.78,8.63 8.73,6.82 11.96,6.82C16.5,6.82 20.21,10.33 20.21,14.65C20.21,16.27 18.83,17.59 17.13,17.59C15.43,17.59 14.05,16.27 14.05,14.65C14.05,13.58 13.12,12.71 11.97,12.71C10.82,12.71 9.89,13.58 9.89,14.65C9.89,16.36 10.55,17.96 11.76,19.16C12.71,20.1 13.62,20.62 15.03,21C15.3,21.08 15.45,21.36 15.38,21.62C15.33,21.85 15.12,22 14.91,22Z"
                  ></path>
                </svg>-->
                Aeps
              </li>
              <li :class="!aeps?'active':''" @click="aeps=false;dmt=true">
                <!-- <svg
                  version="1.1"
                  id="Capa_1"
                  xmlns="http://www.w3.org/2000/svg"
                  xmlns:xlink="http://www.w3.org/1999/xlink"
                  x="0px"
                  y="0px"
                  viewBox="0 0 59.997 59.997"
                  xml:space="preserve"
                  width="40px"
                  height="40px"
                >
                  <g>
                    <path
                      fill="#ff7a00"
                      d="M49.031,32.997c-0.669,0-1.338,0.04-1.998,0.111c-1.362-2.82-3.366-5.301-5.864-7.214l-7.202-4.894
                      c-1.191-0.914-3.068-2.002-5.246-2.002h-7.777c-1.924,0-3.816,0.655-5.3,1.822l-7.078,5.156c-7.377,5.8-9.712,15.964-5.551,24.168
                      c2.002,3.947,4.666,6.227,7.501,6.418c0.271,0.018,0.545,0.028,0.821,0.028h19.154c1.449,2.057,3.838,3.407,6.54,3.407
                      c1.409,0,2.731-0.369,3.882-1.011c1.739,0.633,4.76,1.011,8.118,1.011c9.271,0,9.998-2.22,10-2.903v-4v-0.001v-3.999v-0.001v-3.999
                      v-0.001v-3.999v-0.001v-4C59.031,35.064,53.984,32.997,49.031,32.997z M22.031,27.997c-5.271,0-12,7.29-12,13c0,0.552-0.448,1-1,1
                      s-1-0.448-1-1c0-6.869,7.589-15,14-15c0.552,0,1,0.448,1,1S22.583,27.997,22.031,27.997z M57.031,39.006v1.854
                      c-0.078,0.051-0.191,0.107-0.33,0.165c-0.008,0.003-0.014,0.006-0.022,0.009c-0.138,0.056-0.307,0.114-0.5,0.172
                      c-0.019,0.006-0.036,0.011-0.055,0.017c-0.193,0.057-0.415,0.114-0.659,0.17c-0.032,0.007-0.063,0.015-0.095,0.022
                      c-0.247,0.055-0.519,0.109-0.814,0.16c-0.042,0.007-0.086,0.015-0.129,0.022c-0.301,0.051-0.626,0.098-0.974,0.142
                      c-0.048,0.006-0.098,0.012-0.146,0.018c-0.358,0.043-0.738,0.082-1.143,0.116c-0.048,0.004-0.099,0.007-0.148,0.011
                      c-0.42,0.033-0.86,0.06-1.327,0.079c-0.036,0.001-0.074,0.002-0.11,0.003c-0.491,0.018-1.004,0.03-1.546,0.03
                      c-4.55,0-7.353-0.711-8-1.137v-1.368c1.106,0.092,2.271,0.183,3.378,0.262c1.24,0.15,2.75,0.244,4.622,0.244
                      c0.552,0,1.069-0.009,1.562-0.024c0.163-0.005,0.309-0.014,0.465-0.02c0.318-0.013,0.632-0.027,0.925-0.046
                      c0.172-0.011,0.331-0.025,0.495-0.038c0.253-0.02,0.503-0.041,0.737-0.065c0.16-0.017,0.312-0.035,0.463-0.054
                      c0.214-0.026,0.422-0.053,0.619-0.083c0.142-0.021,0.28-0.043,0.414-0.066c0.186-0.032,0.362-0.065,0.532-0.099
                      c0.12-0.024,0.24-0.049,0.353-0.075c0.164-0.037,0.316-0.077,0.465-0.116c0.098-0.026,0.199-0.052,0.291-0.079
                      c0.148-0.044,0.282-0.089,0.415-0.135c0.073-0.026,0.153-0.05,0.222-0.076C57.003,39.015,57.019,39.011,57.031,39.006z
                      M50.592,43.973c0.164-0.005,0.31-0.014,0.468-0.02c0.317-0.013,0.632-0.027,0.924-0.046c0.171-0.011,0.328-0.025,0.49-0.038
                      c0.255-0.02,0.507-0.041,0.743-0.066c0.158-0.016,0.307-0.035,0.456-0.053c0.216-0.026,0.427-0.054,0.626-0.084
                      c0.139-0.021,0.274-0.042,0.406-0.065c0.189-0.032,0.369-0.066,0.542-0.101c0.117-0.024,0.233-0.047,0.343-0.072
                      c0.169-0.038,0.325-0.079,0.478-0.12c0.094-0.025,0.191-0.05,0.279-0.076c0.155-0.046,0.296-0.094,0.434-0.142
                      c0.067-0.023,0.14-0.046,0.203-0.07c0.015-0.006,0.033-0.011,0.048-0.016v1.854c-0.078,0.051-0.191,0.107-0.33,0.165
                      c-0.008,0.003-0.014,0.006-0.022,0.009c-0.138,0.056-0.307,0.114-0.5,0.172c-0.019,0.006-0.036,0.011-0.055,0.017
                      c-0.193,0.057-0.415,0.114-0.659,0.17c-0.032,0.007-0.063,0.015-0.095,0.022c-0.247,0.055-0.519,0.109-0.814,0.16
                      c-0.042,0.007-0.086,0.015-0.129,0.022c-0.301,0.051-0.626,0.098-0.974,0.142c-0.048,0.006-0.098,0.012-0.146,0.018
                      c-0.358,0.043-0.738,0.082-1.143,0.116c-0.048,0.004-0.099,0.007-0.148,0.011c-0.42,0.033-0.86,0.06-1.327,0.079
                      c-0.036,0.001-0.074,0.002-0.11,0.003c-0.491,0.018-1.004,0.03-1.546,0.03c-4.55,0-7.353-0.711-8-1.137v-1.362
                      c1.297,0.107,2.67,0.211,3.933,0.297c1.265,0.132,2.646,0.202,4.067,0.202C49.583,43.997,50.099,43.988,50.592,43.973z
                      M50.592,47.973c0.164-0.005,0.31-0.014,0.468-0.02c0.317-0.013,0.632-0.027,0.924-0.046c0.171-0.011,0.328-0.025,0.49-0.038
                      c0.255-0.02,0.507-0.041,0.743-0.066c0.158-0.016,0.307-0.035,0.456-0.053c0.216-0.026,0.427-0.054,0.626-0.084
                      c0.139-0.021,0.274-0.042,0.406-0.065c0.189-0.032,0.369-0.066,0.542-0.101c0.117-0.024,0.233-0.047,0.343-0.072
                      c0.169-0.038,0.325-0.079,0.478-0.12c0.094-0.025,0.191-0.05,0.279-0.076c0.155-0.046,0.296-0.094,0.434-0.142
                      c0.067-0.023,0.14-0.046,0.203-0.07c0.015-0.006,0.033-0.011,0.048-0.016v1.854c-0.078,0.051-0.191,0.107-0.33,0.165
                      c-0.008,0.003-0.014,0.006-0.022,0.009c-0.138,0.056-0.307,0.114-0.5,0.172c-0.019,0.006-0.036,0.011-0.055,0.017
                      c-0.193,0.057-0.415,0.114-0.659,0.17c-0.032,0.007-0.063,0.015-0.095,0.022c-0.247,0.055-0.519,0.109-0.814,0.16
                      c-0.042,0.007-0.086,0.015-0.129,0.022c-0.301,0.051-0.626,0.098-0.974,0.142c-0.048,0.006-0.098,0.012-0.146,0.018
                      c-0.358,0.043-0.738,0.082-1.143,0.116c-0.048,0.004-0.099,0.007-0.148,0.011c-0.42,0.033-0.86,0.06-1.327,0.079
                      c-0.036,0.001-0.074,0.002-0.11,0.003c-0.491,0.018-1.004,0.03-1.546,0.03c-0.431,0-0.856-0.008-1.276-0.021
                      c-0.133-0.004-0.263-0.012-0.395-0.017c-0.284-0.012-0.567-0.025-0.843-0.042c-0.15-0.01-0.297-0.022-0.444-0.033
                      c-0.252-0.019-0.501-0.04-0.744-0.065c-0.148-0.015-0.293-0.031-0.437-0.047c-0.064-0.007-0.125-0.016-0.188-0.024
                      c-0.219-0.746-0.544-1.446-0.958-2.085c1.348,0.203,3.063,0.334,5.286,0.334C49.583,47.997,50.099,47.988,50.592,47.973z
                      M50.592,51.973c0.164-0.005,0.31-0.014,0.468-0.02c0.317-0.013,0.632-0.027,0.924-0.046c0.171-0.011,0.328-0.025,0.49-0.038
                      c0.255-0.02,0.507-0.041,0.743-0.066c0.158-0.016,0.307-0.035,0.456-0.053c0.216-0.026,0.427-0.054,0.626-0.084
                      c0.139-0.021,0.274-0.042,0.406-0.065c0.189-0.032,0.369-0.066,0.542-0.101c0.117-0.024,0.233-0.047,0.343-0.072
                      c0.169-0.038,0.325-0.079,0.478-0.12c0.094-0.025,0.191-0.05,0.279-0.076c0.155-0.046,0.296-0.094,0.434-0.142
                      c0.067-0.023,0.14-0.046,0.203-0.07c0.015-0.006,0.033-0.011,0.048-0.016v1.854c-0.078,0.051-0.191,0.107-0.33,0.165
                      c-0.008,0.003-0.014,0.006-0.022,0.009c-0.138,0.056-0.307,0.114-0.5,0.172c-0.019,0.006-0.036,0.011-0.055,0.017
                      c-0.193,0.057-0.415,0.114-0.659,0.17c-0.032,0.007-0.063,0.015-0.095,0.022c-0.247,0.055-0.519,0.109-0.814,0.16
                      c-0.042,0.007-0.086,0.015-0.129,0.022c-0.301,0.051-0.626,0.098-0.974,0.142c-0.048,0.006-0.098,0.012-0.146,0.018
                      c-0.358,0.043-0.738,0.082-1.143,0.116c-0.048,0.004-0.099,0.007-0.148,0.011c-0.42,0.033-0.86,0.06-1.327,0.079
                      c-0.036,0.001-0.074,0.002-0.11,0.003c-0.491,0.018-1.004,0.03-1.546,0.03c-0.648,0-1.279-0.02-1.898-0.049
                      c-0.145-0.007-0.289-0.014-0.432-0.022c-0.602-0.035-1.191-0.081-1.746-0.143c-0.015-0.002-0.028-0.004-0.043-0.006
                      c0.08-0.454,0.12-0.913,0.12-1.372c0-0.075-0.007-0.151-0.009-0.227c0.001-0.061,0.009-0.12,0.009-0.181
                      c0-0.066-0.008-0.13-0.01-0.196c0.815,0.084,1.687,0.131,2.577,0.161c0.406,0.022,0.861,0.035,1.433,0.035
                      C49.583,51.997,50.099,51.988,50.592,51.973z M56.771,36.994c-0.011,0.005-0.023,0.01-0.035,0.015
                      c-0.111,0.048-0.24,0.097-0.393,0.147c-0.016,0.005-0.034,0.01-0.05,0.015c-0.155,0.049-0.329,0.099-0.523,0.149
                      c-0.02,0.005-0.037,0.01-0.057,0.015c-0.202,0.051-0.427,0.1-0.669,0.149c-0.043,0.009-0.086,0.017-0.13,0.026
                      c-0.247,0.048-0.512,0.094-0.798,0.138c-0.04,0.006-0.083,0.012-0.124,0.018c-0.29,0.043-0.596,0.083-0.923,0.12
                      c-0.02,0.002-0.039,0.005-0.059,0.007c-0.333,0.037-0.691,0.068-1.061,0.096c-0.068,0.005-0.136,0.01-0.205,0.015
                      c-0.369,0.026-0.755,0.047-1.158,0.062c-0.072,0.003-0.147,0.005-0.221,0.007c-0.428,0.014-0.869,0.023-1.333,0.023
                      s-0.905-0.009-1.333-0.023c-0.073-0.002-0.148-0.004-0.221-0.007c-0.403-0.015-0.789-0.036-1.158-0.062
                      c-0.069-0.005-0.137-0.01-0.205-0.015c-0.371-0.028-0.728-0.06-1.061-0.096c-0.02-0.002-0.039-0.005-0.059-0.007
                      c-0.327-0.037-0.633-0.077-0.923-0.12c-0.041-0.006-0.084-0.012-0.124-0.018c-0.286-0.044-0.551-0.09-0.798-0.138
                      c-0.044-0.009-0.087-0.017-0.13-0.026c-0.241-0.049-0.467-0.099-0.669-0.149c-0.02-0.005-0.038-0.01-0.057-0.015
                      c-0.194-0.05-0.369-0.1-0.523-0.149c-0.016-0.005-0.035-0.01-0.05-0.015c-0.153-0.05-0.281-0.099-0.393-0.147
                      c-0.012-0.005-0.023-0.01-0.035-0.015c0.927-0.705,3.775-1.997,7.74-1.997S55.844,36.289,56.771,36.994z M31.883,55.064
                      c-0.175-0.293-0.322-0.596-0.444-0.907c-0.008-0.022-0.016-0.044-0.024-0.066c-0.115-0.306-0.207-0.618-0.27-0.937
                      c-0.004-0.022-0.006-0.044-0.01-0.066c-0.055-0.295-0.085-0.595-0.094-0.897c-0.001-0.041-0.006-0.082-0.006-0.124
                      c-0.003-0.303,0.02-0.609,0.063-0.915c0.009-0.065,0.018-0.13,0.03-0.195c0.045-0.26,0.103-0.517,0.182-0.766
                      c0.008-0.027,0.02-0.052,0.029-0.078c0.084-0.251,0.185-0.496,0.302-0.733c0.011-0.023,0.022-0.046,0.033-0.068
                      c0.54-1.059,1.391-1.954,2.424-2.543c0.002-0.001,0.005-0.003,0.007-0.004c0.235-0.134,0.483-0.247,0.735-0.347
                      c0.062-0.024,0.125-0.046,0.188-0.069c0.228-0.082,0.461-0.152,0.7-0.205c0.026-0.006,0.051-0.014,0.077-0.02
                      c0.288-0.059,0.577-0.092,0.865-0.109c0.061-0.004,0.122-0.007,0.183-0.009c0.289-0.009,0.576-0.001,0.861,0.032
                      c0.027,0.003,0.053,0.009,0.081,0.012c0.295,0.038,0.587,0.096,0.875,0.179c0.009,0.003,0.018,0.004,0.027,0.007
                      c0.305,0.089,0.605,0.203,0.897,0.342c2.03,0.963,3.441,3.026,3.441,5.419c0,3.309-2.691,6-6,6
                      C34.844,57.997,32.932,56.817,31.883,55.064z M57.031,56.86c-0.648,0.427-3.452,1.137-8,1.137c-2.215,0-4.3-0.174-5.858-0.475
                      c0.457-0.546,0.838-1.151,1.135-1.802c0.09,0.011,0.187,0.019,0.279,0.03c0.149,0.018,0.301,0.033,0.453,0.049
                      c0.266,0.027,0.536,0.052,0.811,0.073c0.159,0.012,0.316,0.025,0.477,0.036c0.297,0.019,0.599,0.034,0.904,0.047
                      c0.143,0.006,0.284,0.014,0.429,0.019c0.451,0.014,0.907,0.023,1.37,0.023c0.551,0,1.068-0.009,1.561-0.024
                      c0.164-0.005,0.31-0.014,0.468-0.02c0.317-0.013,0.632-0.027,0.924-0.046c0.171-0.011,0.328-0.025,0.49-0.038
                      c0.255-0.02,0.507-0.041,0.743-0.066c0.158-0.016,0.307-0.035,0.456-0.053c0.216-0.026,0.427-0.054,0.626-0.084
                      c0.139-0.021,0.274-0.042,0.406-0.065c0.189-0.032,0.369-0.066,0.542-0.101c0.117-0.024,0.233-0.047,0.343-0.072
                      c0.169-0.038,0.325-0.079,0.478-0.12c0.094-0.025,0.191-0.05,0.279-0.076c0.155-0.046,0.296-0.094,0.434-0.142
                      c0.067-0.023,0.14-0.046,0.203-0.07c0.015-0.006,0.033-0.011,0.048-0.016V56.86z"
                    ></path>
                    <path
                      fill="#ff7a00"
                      d="M32.031,16.304v-2.307c0-0.552-0.448-1-1-1h-12c-0.552,0-1,0.448-1,1s0.448,1,1,1h11v1h-11c-0.552,0-1,0.448-1,1
                      s0.448,1,1,1h11.925c0.896,0.746,2,1.173,3.179,1.173c1.335,0,2.591-0.521,3.536-1.466c0.391-0.391,0.391-1.023,0-1.414
                      s-1.023-0.391-1.414,0C35.127,17.419,33.168,17.423,32.031,16.304z"
                    ></path>
                    <path
                      fill="#ff7a00"
                      d="M18.086,10.027c0.407,1.178,1.504,1.97,2.73,1.97h7.431c1.226,0,2.323-0.792,2.73-1.97
                      c0.388-1.126,1.607-3.645,2.553-4.445c0.829-0.703,1.218-1.792,1.014-2.842c-0.2-1.033-0.921-1.849-1.928-2.182
                      c-2.999-0.993-5.666-0.658-7.698,0.967c-0.357,0.287-0.86,0.287-1.22,0c-2.032-1.625-4.701-1.96-7.697-0.967
                      c-1.007,0.333-1.729,1.148-1.929,2.182c-0.204,1.05,0.185,2.139,1.014,2.842C16.156,6.489,17.796,9.187,18.086,10.027z"
                    ></path>
                  </g>
                </svg>-->
                DMT
              </li>
            </ul>
          </v-flex>
        </v-layout>
        <transition name="fadeY" mode="out-in">
          <v-layout row wrap pt-4 v-if="aeps">
            <v-flex xs12>
              <h2>Aadhaar Enable Payment System</h2>
              <h3 class="pb-3">Micro-ATM, in partnership with RBL Bank Ltd.</h3>
            </v-flex>
            <v-flex md5 xs12>
              <p>Spice Money micro-ATM, in partnership with RBL Bank Ltd. and Kotak Mahindra Bank facilitate customers to perform basic banking transactions on his/her Aadhaar-linked bank account using Aadhaar authentication as the identifier.</p>
            </v-flex>
            <v-flex md7 xs12 :class="this.$vuetify.breakpoint.lgAndUp?'pl-5':'pt-3'">
              <p>The basic banking transactions are outlined below:</p>
              <ul class="standard-listing">
                <li>Balance Inquiry</li>
                <li>Cash withdrawal</li>
              </ul>
            </v-flex>
          </v-layout>
        </transition>
        <transition name="fadeY" mode="out-in">
          <v-layout row wrap pt-4 v-if="dmt">
            <v-flex xs12>
              <h2>Direct Money Transfer</h2>
              <h3 class="pb-3">Providing digital payment solutions</h3>
            </v-flex>
            <v-flex md12 xs12>
              <p>Spice Money Wallet (issued by Spice Digital Ltd.), is a RBI approved Semi-closed PPI wallet linked to Sender’s Mobile Number. A robust and convenient tool for financial inclusion, Spice Money is predominantly used for Domestic Money Remittance, Cash deposit to Bank Accounts through agent assisted model. Additionally, we have tied up with 2 Banks to become its Business Correspondent (BC), namely IndusInd Bank Ltd. and Yes Bank Ltd. to enable money remittance using Banking channel.</p>
              <h3>Purpose</h3>
              <p>To provide remittance solutions to the underserved section of the society through Spice Money strong Agent Network</p>
              <h3>How does it work?</h3>
              <p>Spice Money Agent opens a Spice Money wallet (semi-closed) of sender using OTP on his/her Mobile. The Sender’s wallet is credited with an amount equal to the money to be remitted using O2O payments. Using IMPS/NEFT the wallet load of sender is transferred to the bank account in India.</p>
              <h3>DMT – PPI – Product features</h3>
              <ul class="standard-listing two">
                <li>Opening a Sender’s PPI (semi-closed) wallet (Basic and KYC) by an Agent and assigning a m-PIN</li>

                <li>Adding a beneficiary bank account details using Bank Account Number and IFSC Code</li>

                <li>Verifying Beneficiary Bank Account details</li>

                <li>Single click : i) Sender’s wallet is loaded by Agent and ii) Pre-paid load is transferred to Bank account</li>

                <li>Generating a receipt/SMS confirming the status of Money remittance for the Sender</li>
              </ul>
            </v-flex>
          </v-layout>
        </transition>
      </v-card-text>
    </v-card>
  </div>
</template>

<style scoped>
.v-toolbar__title {
  color: #2a3997 !important;
}
.title {
  text-transform: uppercase;
  font-size: 64px !important;
  color: #000;
  font-weight: 100;
}
.title span {
  font-weight: 900;
}
h2 {
  font-size: 30px;
  padding-bottom: 15px;
}
p {
  font-size: 15px;
  line-height: 20px;
  margin-bottom: 10px;
  color: #333;
}

.content-img {
  -webkit-box-shadow: 0 5px 20px 0 rgba(54, 57, 73, 0.09);
  box-shadow: 0 5px 20px 0 rgba(54, 57, 73, 0.09);
}
.logo-inner {
  align-items: center;
}
.nav-listing {
  list-style: none;
  display: flex;
  flex-direction: row;
}
.nav-listing li {
  margin-left: 10px;
}
.nav-listing li a {
  text-decoration: none;
  padding: 10px 15px;
  transition: all ease-in-out 0.2s;
  color: #475055;
  font-size: 16px;
}
.nav-listing li a:hover,
.nav-listing li a.active {
  color: #4385f3;
}

.icon-triggers {
  list-style: none;
  margin: 0;
  padding: 12px 0 0px 50px;
  background: #293896;
}
.icon-triggers li {
  position: relative;
  cursor: pointer;
  display: inline-flex;
  flex-direction: column;
  align-items: center;
  color: #fff;
  min-width: 100px;
  text-transform: uppercase;
  font-size: 16px;
  font-weight: 500;
  padding-bottom: 5px;
  opacity: 0.7;
  border-bottom: solid 3px tranparent;
  margin-right: 5px;
}
.icon-triggers li.active,
.icon-triggers li:hover {
  opacity: 1;
  border-bottom: solid 3px orange;
}

/* .icon-triggers li.active,
.icon-triggers li:hover {
  background-color: rgb(255, 122, 0);
  color: #fff;

  animation: none;
}
.icon-triggers path {
  transition: all ease-in-out 0.6s;
}
.icon-triggers li path,
.icon-triggers li path {
  fill: rgb(255, 122, 0);
}

.icon-triggers li.active path,
.icon-triggers li:hover path {
  fill: #fff;
}

.icon-triggers li.active:hover {
  cursor: default;
}

.icon-triggers li:not(.active):hover:before {
  border-top-color: #ff7a00;
  border-right-color: #ff7a00;
  border-bottom-color: #ff7a00;
  -webkit-transition: border-top-color 0.15s linear,
    border-right-color 0.15s linear 0.1s, border-bottom-color 0.15s linear 0.2s;
  transition: border-top-color 0.15s linear,
    border-right-color 0.15s linear 0.1s, border-bottom-color 0.15s linear 0.2s;
}

.icon-triggers li:not(.active):hover:after {
  border-top: 3px solid #ff7a00;
  border-left-width: 2px;
  border-right-width: 2px;
  -webkit-transform: rotate(540deg);
  -ms-transform: rotate(540deg);
  transform: rotate(540deg);
  -webkit-transition: border-left-width 0s linear 0.35s,
    -webkit-transform 0.4s linear 0s;
  transition: border-left-width 0s linear 0.35s,
    -webkit-transform 0.4s linear 0s;
  transition: transform 0.4s linear 0s, border-left-width 0s linear 0.35s;
  transition: transform 0.4s linear 0s, border-left-width 0s linear 0.35s,
    -webkit-transform 0.4s linear 0s;
}

.icon-triggers li:hover:after {
  opacity: 1;
} */

@-webkit-keyframes categoryTriggerPulse {
  0% {
    -webkit-box-shadow: 0 0 0 0 rgb(255, 122, 0, 0.8);
  }
  50% {
    -webkit-box-shadow: 0 0 0 15px rgba(255, 122, 0, 0);
  }
  100% {
    -webkit-box-shadow: 0 0 0 0 rgba(255, 122, 0, 0);
  }
}

@keyframes categoryTriggerPulse {
  0% {
    -moz-box-shadow: 0 0 0 0 rgba(255, 122, 0, 0.8);
    box-shadow: 0 0 0 0 rgba(255, 122, 0, 0.8);
  }
  50% {
    -moz-box-shadow: 0 0 0 15px rgba(255, 122, 0, 0);
    box-shadow: 0 0 0 15px rgba(255, 122, 0, 0);
  }
  100% {
    -moz-box-shadow: 0 0 0 0 rgba(255, 122, 0, 0);
    box-shadow: 0 0 0 0 rgba(255, 122, 0, 0);
  }
}

.standard-listing {
  color: #343434;
}
.standard-listing.two li {
  width: 100%;
}
.standard-listing li {
  float: left;
  width: 50%;
}
.leadership-designation {
  color: #242424;
  font-size: 20px;
  font-weight: 300;
  list-style: none;
  padding: 0;
  min-height: 150px;
}

.earn-now {
  position: relative;
  padding: 25px 30px;
  background: #2d2d2d;
  font-size: 30px;
  color: #fff;
  font-family: "Poppins", sans-serif;
  font-weight: bold;
}
.join-now {
  background: #ec1c25;
  padding: 0px 45px;
  height: 83px;
  line-height: 83px;
  text-transform: uppercase;
  color: #fff;
  display: inline-block;
  font-size: 30px;
  font-weight: 900;
  font-family: "Montserrat", sans-serif;
  text-decoration: none;
  text-shadow: 2px 2px 2px rgba(0, 0, 0, 0.52);
  z-index: 2;
  transition: all ease-in-out 0.3s;
}

.join-now:hover {
  border-radius: 5px;
  -webkit-box-shadow: 5px 5px 6px 0px rgba(0, 0, 0, 0.67);
  box-shadow: 5px 5px 6px 0px rgba(0, 0, 0, 0.67);
}

@media only screen and (max-width: 768px) {
  .title {
    font-size: 18px !important;
  }
  .earn-now {
    position: relative;
    padding: 15px 20px;
    font-size: 22px;
  }
  .join-now {
    padding: 0px 25px;
    height: 40px;
    line-height: 40px;
    font-size: 20px;
    margin-top: 15px;
  }
  .icon-triggers li {
    width: 40px;
    height: 40px;
    padding: 5px;
  }
  h2 {
    font-size: 16px;
  }
  h3 {
    font-size: 14px;
  }
  .standard-listing li {
    width: 100%;
  }
}
@media only screen and (max-width: 550px) {
  .icon-triggers {
    padding: 0;
  }
  .icon-triggers li {
    width: 100%;
    margin: 0;
    padding: 0;
    line-height: 40px;
  }
}
</style>

<script>
import BankingDetails from "./BankingDetails.ts";
export default BankingDetails;
</script>